import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import '../Assistant/Assistant.css';
import '../CallHistory/CallHistory.css'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Modal from '@mui/material/Modal';
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
// import './ContactList.css'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// date
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import TablePagination from '@mui/material/TablePagination';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import AddIcon from '@mui/icons-material/Add';



const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
];
function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#2F024E',
        color: '#fff',

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 10,
        border: 'none',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: 'rgba(226, 186, 253, 0.30)',
        border: 'none',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 'none',
    },
}));

const drawerWidth = 300;

const PhoneNumberHome = () => {
    const notify = () => toast.success('Setup Completed');
    const remove = () => toast.success('Deleted successfully');

    const theme = useTheme();
    const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

    const [pop, setPop] = useState(false);
    const handlePopOpen = () => setPop(true);
    const handlePopClose = () => setPop(false);

    const navigate = useNavigate();

    // TablePagination-start
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(3);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)

        setPage(0);
    };
    // TablePagination-end     
  return (
    <div className="PhoneNumberHome">
    <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        <SideBar />
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: isLgUp ? 5 : 1,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
                marginTop: isLgUp ? "0px" : "80px",
            }}
        >
            <h3>Phone Number</h3>
            <div className="graient-btn mt-30">
                <Button className="display-1" onClick={() => {
                    navigate("/Create-campaign");
                }}>CREATE NEW CAMPAIGN <AddIcon /></Button>
            </div>
            <Grid2 container spacing={1} sx={{ alignItems: 'center', marginTop: '20px' }}>
                <Grid2
                    item
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    className="mb-20"
                >
                    <div className="ContactListTable-main">
                        <TableContainer component={Paper} sx={{ maxHeight: 440, borderRadius: '20px 20px 0px 0px' }}>
                            <Table sx={{ minWidth: 700 }} stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center">SI.No</StyledTableCell>
                                        <StyledTableCell align="center">Name</StyledTableCell>
                                        <StyledTableCell align="center">Created At</StyledTableCell>
                                        <StyledTableCell align="center">Total Users</StyledTableCell>
                                        <StyledTableCell align="center">Status</StyledTableCell>
                                        <StyledTableCell align="center"></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row) => (
                                        <StyledTableRow key={row.name}>
                                            <StyledTableCell component="th" align="center"><Link to='/contact-list-view'><h4>1  </h4> </Link></StyledTableCell>
                                            <StyledTableCell align="center"><h4>Sales  Outbound Tesla</h4></StyledTableCell>
                                            <StyledTableCell align="center"><h4>7 Jan 2025 </h4></StyledTableCell>
                                            <StyledTableCell align="center"><h4 >10</h4></StyledTableCell>
                                            <StyledTableCell align="center"><h4 className="green">Completed</h4></StyledTableCell>  {/*color for orange text => className="orange" */}
                                            <StyledTableCell align="center">     <Link to='/campaign-overview' className="View Details"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                                                <g clip-path="url(#clip0_904_10527)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.51953 12.7613C2.93107 10.8946 4.18453 9.83542 5.27992 9.58375C6.3753 9.33208 7.41819 9.29406 8.40857 9.46969L8.40857 12.8125L13.058 7.35781L8.40857 2.1875L8.40857 5.36469C6.57722 5.38031 5.0203 6.09208 3.7378 7.5C2.45568 8.90792 1.71626 10.6617 1.51953 12.7613Z" fill="white" stroke="white" stroke-width="1.76471" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_904_10527">
                                                        <rect width="14.4231" height="15" fill="white" transform="translate(0.878906)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                                View Details
                                            </Link>

                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="Pagination-main">
                            <TablePagination
                                rowsPerPageOptions={[3, 25, 100]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
        </Box>
    </Box>
</div>
  )
}

export default PhoneNumberHome